function EntityAvatar({ photoUrl, name, className, textClassName, entityLabel = 'Record' }) {
  if (photoUrl) {
    return (
      <div className={`overflow-hidden rounded-full bg-[var(--theme-accent-soft)] ${className || ''}`}>
        <img
          className="h-full w-full object-cover"
          src={photoUrl}
          alt={`${name || entityLabel} profile`}
        />
      </div>
    );
  }

  return (
    <div
      className={`grid place-items-center rounded-full bg-[var(--theme-accent)] text-white shadow-[0_8px_18px_rgba(var(--theme-shadow-rgb),0.14)] ${className || ''} ${textClassName || ''}`}
      aria-label={`${name || entityLabel} fallback avatar`}
    >
      {getInitials(name)}
    </div>
  );
}

function getInitials(value) {
  const parts = (value || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);

  if (!parts.length) {
    return 'R';
  }

  return parts.map((part) => part[0].toUpperCase()).join('');
}

export default EntityAvatar;
